import reducer from "./reducer";
export { default as GalleryDialog } from "./components/index";
export { default as galleryDialogReducerName } from "./constants";
export default reducer;
